import { appSessionRestoreSlice, getMapInstance } from "..";
import type { MemorySliceDescriptor } from "../../shared";
import { ephemeralStore } from "../runtime/ephemeralStore";
import { ALL_EPHEMERAL_SLICES } from "../slices/registry";

/**
 * Builds a JSON-serializable snapshot of all ephemeral slices for error reporting.
 *
 * @returns Plain object keyed by slice key; map instance is summarized, not embedded.
 */
export const buildEphemeralSlicesSnapshot = (): Record<string, unknown> => {
    const snapshot: Record<string, unknown> = { "mapInstance": { "mapRegistered": getMapInstance() !== undefined } };

    for ( const slice of ALL_EPHEMERAL_SLICES ) {
        snapshot[slice.key] = ephemeralStore.peek( slice as MemorySliceDescriptor<unknown> );
    }

    const appSessionRestore = ephemeralStore.peek( appSessionRestoreSlice );
    snapshot.appSessionRestore = {
        "isRestoring":         appSessionRestore.isRestoring,
        "pendingSnapshotKeys": appSessionRestore.pendingSnapshot === null
            ? []
            : Object.keys( appSessionRestore.pendingSnapshot ).filter( ( key ) => key !== "version" && key !== "savedAt" ),
        "restoredKeys":            appSessionRestore.restoredKeys,
        "skipNextItinerarySearch": appSessionRestore.skipNextItinerarySearch,
    };

    return snapshot;
};
